/* =========================================================================
   Prototyp Onlineshop Solar – Overlay-Mechanik für Schubladen und Dialoge

   EINE Mechanik statt dreier. Im Theme standen bisher nebeneinander: das
   native <dialog> der Lightbox (sections/main-product.liquid), eine
   handgebaute Schublade in assets/cart.js und beim Menü gar keine – dessen
   Zustand steckte in einem Inline-onclick in sections/header.liquid. Diese
   Datei trägt Öffnen, Schliessen, Escape, Fokusfang, Fokusrückgabe,
   Hintergrund und Bildlaufsperre genau einmal. Die Menü-Schublade nutzt sie
   ab Stufe 2 des Mobilumbaus, assets/cart.js zieht sich in Stufe 3 darauf
   zurück und verliert dabei seine Duplikate.

   ÖFFENTLICHE SCHNITTSTELLE
   -------------------------
   var ov = window.Overlay.create({
     panel:        Element | CSS-Auswahl   PFLICHT – die Fläche selbst.
                                           Sie muss ein Kind von <body> sein
                                           (siehe INERT weiter unten).
     backdrop:     Element | CSS-Auswahl   der abdunkelnde Hintergrund;
                                           ein Klick darauf schliesst.
     trigger:      Element | CSS-Auswahl   der Knopf, der öffnet. Er bekommt
                                           aria-expanded mitgeführt und nach
                                           dem Schliessen den Fokus zurück.
     initialFocus: Element | CSS-Auswahl   was nach dem Öffnen den Fokus
                                           bekommt. Ohne Angabe die Fläche
                                           selbst (tabindex="-1" genügt).
     closeAbove:   '--bp-nav' | Zahl       schliesst selbsttätig, sobald das
                                           Fenster über diese Breite wächst.
                                           Ein Token-Name wird aus :root
                                           gelesen – damit ist die Schwelle
                                           für CSS und Skript dieselbe Zahl.
     onOpen(ov) / onClose(ov)              Rückrufe, z. B. zum Nachladen.
   });

   ov.open() · ov.close() · ov.toggle() · ov.isOpen()
   ov.panel · ov.backdrop · ov.trigger
   window.Overlay.closeAll()              schliesst jede offene Fläche
   window.Overlay.breakpoint('--bp-nav')  liest eine Umbruchschwelle aus :root

   Ein zweiter Aufruf von create() mit derselben Fläche liefert die vorhandene
   Steuerung zurück, statt eine zweite daneben zu stellen – sonst hingen nach
   einem Section-Neuaufbau im Theme-Editor zwei Klickzuhörer am Hintergrund.

   ZUSTAND steht als Klasse `is-open` an Fläche und Hintergrund. In dieser
   Datei steht kein einziger Stilwert; alles Sichtbare kommt aus base.css.

   BILDLAUFSPERRE über position: fixed am <body> mit gemerkter Scrollposition,
   NICHT über overflow: hidden – Letzteres hält iOS Safari nicht zuverlässig
   auf, dort scrollt die Seite hinter der Schublade weiter, und man steht nach
   dem Schliessen an einer anderen Stelle als vorher.

   INERT: Beim Öffnen wird jedes Kind von <body> stillgelegt, das nicht zur
   offenen Fläche gehört. Der Fokusfang ist damit kein Nachbau mit
   Tab-Zählerei, sondern der Zustand, den der Browser selbst kennt – er umfasst
   auch Zeiger und Vorlesehilfen. Für Maschinen ohne `inert` bleibt der
   Tab-Fang als Rückfall stehen. Deshalb die Bedingung oben: liegt die Fläche
   tiefer im Baum, wird ihr body-naher Vorfahre verschont, sonst legte die
   Sperre die eigene Schublade mit still.
   ========================================================================= */
(function () {
  'use strict';

  var offene = [];        // Stapel der offenen Steuerungen, zuletzt geöffnete zuletzt
  var stillgelegt = [];   // Elemente, die WIR inert gesetzt haben
  var merkeY = 0;         // Scrollposition vor der Sperre

  var FOKUSSIERBAR = 'a[href],button:not([disabled]),input:not([disabled]),'
    + 'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function knoten(x) {
    if (!x) return null;
    return typeof x === 'string' ? document.querySelector(x) : x;
  }

  /* Der body-nahe Vorfahre eines Elements. Nur er darf von der Stilllegung
     ausgenommen werden – inert vererbt sich nach unten und lässt sich in
     einem Nachfahren nicht wieder aufheben. */
  function ebene(el) {
    while (el && el.parentNode && el.parentNode !== document.body) el = el.parentNode;
    return el;
  }

  function schwelle(wert) {
    if (typeof wert === 'number') return wert;
    if (!wert) return 0;
    var roh = getComputedStyle(document.documentElement).getPropertyValue(String(wert));
    var zahl = parseInt(String(roh).trim(), 10);
    return isNaN(zahl) ? 0 : zahl;
  }

  function sperren() {
    if (offene.length !== 1) return;      // nur die erste offene Fläche sperrt
    merkeY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-merkeY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
  }

  function entsperren() {
    if (offene.length) return;            // eine andere Fläche ist noch offen
    var b = document.body;
    b.style.position = ''; b.style.top = ''; b.style.left = '';
    b.style.right = ''; b.style.width = '';
    /* scroll-behavior: smooth steht global an <html>; ohne diese Klammer
       kriecht die Seite nach dem Schliessen sichtbar an ihre alte Stelle
       zurück, statt einfach dort zu stehen. */
    var h = document.documentElement, vorher = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    window.scrollTo(0, merkeY);
    h.style.scrollBehavior = vorher;
  }

  function stilllegungAktualisieren() {
    stillgelegt.forEach(function (el) { el.inert = false; });
    stillgelegt = [];
    if (!offene.length) return;

    /* Der Auslöser muss ebenso verschont bleiben wie Fläche und Hintergrund:
       er sitzt bei der Menü-Schublade in der Kopfzeile (sections/header.liquid),
       einem eigenen body-nahen Geschwister von Fläche und Hintergrund, die auf
       Body-Ebene liegen (snippets/nav-drawer.liquid). Ohne diese Zeile legt
       inert die ganze Kopfzeile samt Menütaste still, sobald die Schublade
       offen ist – die als sichtbare Schliessgeste gedachte Taste wäre dann
       weder klickbar noch per Tab erreichbar. */
    var verschont = [];
    offene.forEach(function (ov) {
      verschont.push(ebene(ov.panel));
      if (ov.backdrop) verschont.push(ebene(ov.backdrop));
      if (ov.trigger) verschont.push(ebene(ov.trigger));
    });

    Array.prototype.forEach.call(document.body.children, function (kind) {
      if (verschont.indexOf(kind) !== -1) return;
      if (kind.tagName === 'SCRIPT' || kind.tagName === 'TEMPLATE') return;
      if (kind.inert) return;             // war schon vorher stillgelegt: nicht anfassen
      kind.inert = true;
      stillgelegt.push(kind);
    });
  }

  /* Rückfall für Maschinen ohne inert: Tab am Rand der Fläche umbiegen. */
  function tabFang(e) {
    if (e.key !== 'Tab' || !offene.length) return;
    var oben = offene[offene.length - 1];
    if ('inert' in HTMLElement.prototype) return;
    var ziele = oben.panel.querySelectorAll(FOKUSSIERBAR);
    if (!ziele.length) { e.preventDefault(); oben.panel.focus(); return; }
    var erstes = ziele[0], letztes = ziele[ziele.length - 1];
    if (e.shiftKey && (document.activeElement === erstes || document.activeElement === oben.panel)) {
      e.preventDefault(); letztes.focus();
    } else if (!e.shiftKey && document.activeElement === letztes) {
      e.preventDefault(); erstes.focus();
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && offene.length) {
      e.preventDefault();
      offene[offene.length - 1].close();
      return;
    }
    tabFang(e);
  });

  function create(o) {
    var panel = knoten(o && o.panel);
    if (!panel) return null;
    if (panel.__overlay) {
      /* Zweiter Aufruf für dieselbe Fläche (Theme-Editor baut die Section neu
         auf): nur die Verweise auffrischen, keine zweite Steuerung. */
      var vorhanden = panel.__overlay;
      if (o.trigger) vorhanden.trigger = knoten(o.trigger);
      return vorhanden;
    }

    var ov = {
      panel: panel,
      backdrop: knoten(o.backdrop),
      trigger: knoten(o.trigger),
      isOpen: function () { return offene.indexOf(ov) !== -1; }
    };
    var rueckgabeZiel = null;

    ov.open = function () {
      if (ov.isOpen()) return;
      rueckgabeZiel = document.activeElement;
      offene.push(ov);
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      if (ov.backdrop) ov.backdrop.classList.add('is-open');
      if (ov.trigger) ov.trigger.setAttribute('aria-expanded', 'true');
      sperren();
      stilllegungAktualisieren();
      var ziel = knoten(o.initialFocus) || panel;
      if (ziel === panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      ziel.focus({ preventScroll: true });
      if (typeof o.onOpen === 'function') o.onOpen(ov);
    };

    ov.close = function () {
      var i = offene.indexOf(ov);
      if (i === -1) return;
      offene.splice(i, 1);
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (ov.backdrop) ov.backdrop.classList.remove('is-open');
      if (ov.trigger) ov.trigger.setAttribute('aria-expanded', 'false');
      stilllegungAktualisieren();   // erst beleben …
      entsperren();
      /* … dann den Fokus zurückgeben: auf ein stillgelegtes Element lässt er
         sich nicht setzen, und die Menütaste liegt in der Kopfzeile, die
         soeben noch inert war. */
      if (rueckgabeZiel && document.contains(rueckgabeZiel)) {
        rueckgabeZiel.focus({ preventScroll: true });
      } else if (ov.trigger) {
        ov.trigger.focus({ preventScroll: true });
      }
      rueckgabeZiel = null;
      if (typeof o.onClose === 'function') o.onClose(ov);
    };

    ov.toggle = function () { ov.isOpen() ? ov.close() : ov.open(); };

    if (ov.backdrop) ov.backdrop.addEventListener('click', ov.close);

    if (o.closeAbove) {
      var px = schwelle(o.closeAbove);
      if (px && window.matchMedia) {
        var mq = window.matchMedia('(min-width: ' + (px + 1) + 'px)');
        var reagieren = function (e) { if (e.matches) ov.close(); };
        if (mq.addEventListener) mq.addEventListener('change', reagieren);
        else if (mq.addListener) mq.addListener(reagieren);
      }
    }

    panel.__overlay = ov;
    return ov;
  }

  window.Overlay = {
    create: create,
    breakpoint: schwelle,
    closeAll: function () { offene.slice().reverse().forEach(function (ov) { ov.close(); }); }
  };
})();

/* =========================================================================
   Fragezeichen-Erklärungen (.infotip) – Stufe 4 des Mobilumbaus

   Warum hier und nicht in assets/product.js: dieselben Erklärungen stehen
   elfmal im Theme – neunmal im Amortisationsrechner der Startseite, einmal am
   Ertragsrechner der Produktseite und einmal in der Technik-Tabelle. product.js
   lädt auf der Startseite nicht. Diese Datei lädt auf jeder Seite, und ein
   Aufklappmechanismus an zwei Stellen wären zwei Wahrheiten.

   Warum überhaupt ein Skript: bis Stufe 4 hing das Aufklappen ausschliesslich
   an :hover, :focus und :focus-within. Auf einem Touchgerät gibt es keines
   davon verlässlich – die elf Erklärungen waren mit dem Finger überhaupt nicht
   zu öffnen. Den Zustand trägt jetzt aria-expanded am <button>, und das CSS
   hängt an genau diesem Attribut.

   Ereignisdelegation über das Dokument statt eines Zuhörers je Fragezeichen:
   der Amortisationsrechner allein bringt neun mit, und der Klick DANEBEN – der
   die offene Erklärung schliesst – muss ohnehin am Dokument hängen.
   ========================================================================= */
(function () {
  function offene() {
    return document.querySelectorAll('.infotip[aria-expanded="true"]');
  }

  function schliessen(ausser) {
    Array.prototype.forEach.call(offene(), function (b) {
      if (b !== ausser) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var tip = e.target && e.target.closest ? e.target.closest('.infotip') : null;
    if (!tip) { schliessen(null); return; }
    /* preventDefault ist hier kein Beiwerk: an sieben der elf Stellen steht das
       Fragezeichen in einer Zeile mit einem <label for="...">. Ohne das
       Abbrechen der Vorgabe fokussierte derselbe Tipp zusätzlich das Zahlenfeld
       daneben, und auf dem Telefon spränge die Bildschirmtastatur auf. */
    e.preventDefault();
    var war = tip.getAttribute('aria-expanded') === 'true';
    schliessen(tip);
    tip.setAttribute('aria-expanded', war ? 'false' : 'true');
  });

  /* Escape schliesst und gibt den Fokus zurück – dieselbe Zusage wie bei den
     Schubladen weiter oben. Nur wenn wirklich eine Erklärung offen ist, sonst
     nähme diese Zeile der Schublade ihr Escape weg. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var auf = document.querySelector('.infotip[aria-expanded="true"]');
    if (!auf) return;
    e.stopPropagation();
    schliessen(null);
    auf.focus({ preventScroll: true });
  });

  /* Wer per Tabulator weitergeht, hat die Erklärung gelesen. Ohne das bliebe
     sie als Streifen über dem unteren Bildschirmrand stehen, während der Fokus
     längst drei Felder weiter ist. */
  document.addEventListener('focusin', function (e) {
    var tip = e.target && e.target.closest ? e.target.closest('.infotip') : null;
    if (!tip) schliessen(null);
  });
})();
